import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { createStyles, makeStyles, Link as MaterialLink, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => {
  return createStyles({
    link: {
      padding: '2px 5px 2px 0',
      '& button': {
        textAlign: 'left',
        textTransform: 'none',
      },
      '& h5': {
        color: theme.palette.primary.main,

        '&:hover': {
          color: theme.palette.primary.dark,
        },
      },
    },
  });
});

interface IProfileLink {
  label: string;
  path: string;
}

const ProfileLink: FC<IProfileLink> = ({ label, path }) => {
  const classes = useStyles();

  return (
    <Link className={classes.link} to={path}>
      <MaterialLink component="button" underline="none">
        <Typography variant="h5">{label}</Typography>
      </MaterialLink>
    </Link>
  );
};

export default ProfileLink;
